(function () {
  'use strict';

  function bindCouponCopy(root) {
    root.querySelectorAll('[data-coupon-copy]').forEach((button) => {
      if (button.dataset.couponCopyInit === 'true') return;
      button.dataset.couponCopyInit = 'true';

      button.addEventListener('click', async () => {
        const code = button.dataset.couponCode;
        if (!code) return;

        const copiedLabel = button.dataset.copiedLabel || 'Copied!';
        const originalLabel = button.textContent;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const helper = document.createElement('textarea');
            helper.value = code;
            helper.setAttribute('readonly', '');
            helper.style.position = 'fixed';
            helper.style.left = '-9999px';
            document.body.appendChild(helper);
            helper.select();
            document.execCommand('copy');
            document.body.removeChild(helper);
          }

          button.textContent = copiedLabel;
          button.classList.add('is-copied');
          window.setTimeout(() => {
            button.textContent = originalLabel;
            button.classList.remove('is-copied');
          }, 2000);
        } catch (error) {
          button.textContent = 'Copy failed';
          window.setTimeout(() => {
            button.textContent = originalLabel;
          }, 2000);
        }
      });
    });
  }

  function bindCouponDots(slider) {
    const track = slider.querySelector('[data-coupon-track]');
    const dots = [...slider.querySelectorAll('[data-coupon-dot]')];
    const slides = [...slider.querySelectorAll('[data-coupon-slide]')];

    if (!track || !dots.length || !slides.length) return;
    if (slider.dataset.couponDotsInit === 'true') return;
    slider.dataset.couponDotsInit = 'true';

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    const getActiveIndex = () => {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    let scrollTick = null;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollTick) return;
        scrollTick = window.requestAnimationFrame(() => {
          scrollTick = null;
          setActiveDot(getActiveIndex());
        });
      },
      { passive: true }
    );

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveDot(index);
      });
    });

    setActiveDot(0);
  }

  function initProductCoupons(root = document) {
    const scope = root.querySelectorAll ? root : document;
    bindCouponCopy(scope);
    scope.querySelectorAll('[data-coupon-slider]').forEach(bindCouponDots);
  }

  window.initProductCoupons = initProductCoupons;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductCoupons());
  } else {
    initProductCoupons();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductCoupons(event.target);
  });
})();
